export const mediaQueryConstants = {
  MEDIUM: 768,
  LARGE: 992
};
